
/* CIDADE E ESTADOS */

$(".adiciona-cidadeestado").on("click", function (e) {
  e.preventDefault();
  adicionaCamposCD();
});

function removeCamposCD(acionado) {
  $(acionado).parent().remove();
}

$(".conta-bloco").on("click", ".remove-novo-atributoCD", function (e) {
  e.preventDefault();
  removeCamposCD($(this));
});

function adicionaCamposCD() {
  var html = "";

  var maxID = 0;
  $(".linha-variacoesCD").each(function () {
    var curID = Number($(this).data("reg"));
    if (curID > maxID) {
      maxID = curID;
    }
  });
  let nextID = maxID + 1;

  html +=
    '<div class="linha-variacoesCD" data-reg="' +
    nextID +
    '" style="margin-bottom: 20px"> <div class="row"> <div class="grid-3 grid-m-6 grid-s-12 campo-container"> <input name="cidades_estados_atendimento[' +
    nextID +
    '][cidade]" id="cidade" type="text" value="" placeholder="Cidade" class="campo"> </div> <div class="grid-3 grid-m-6 grid-s-12 campo-container"> <input name="cidades_estados_atendimento[' +
    nextID +
    '][estado]" id="estado" type="text" value="" placeholder="Estado" class="campo"> </div> <div class="grid-3 grid-m-6 grid-s-12 campo-container"> <input name="cidades_estados_atendimento[' +
    nextID +
    '][bairro]" id="bairro" type="text" value="" placeholder="Bairro" class="campo"> </div> <a class="remove-novo-atributoCD btn btn-xs btn-warning" style="position: relative; top: 7px; left: 10px; cursor: pointer"><i class="fa fa-trash"></i> <strong>Remover</strong></a> </div>';


  $("#imendaHTMLCD").append(html);
}

/* CIDADE E ESTADOS */


/* FAQ */

$(".adiciona-faq").on("click", function (e) {
  e.preventDefault();
  adicionaCamposFAQ();
});

function removeCamposFAQ(acionado) {
  $(acionado).parent().remove();
}

$(".conta-bloco").on("click", ".remove-novo-atributoFAQ", function (e) {
  e.preventDefault();
  removeCamposFAQ($(this));
});

function adicionaCamposFAQ() {
  var html = "";

  var maxID = 0;
  $(".linha-variacoesFAQ").each(function () {
    var curID = Number($(this).data("reg"));
    if (curID > maxID) {
      maxID = curID;
    }
  });
  let nextID = maxID + 1;

  html +=
    '<div class="linha-variacoesFAQ" data-reg="' +
    nextID +
    '" style="margin-bottom: 20px"> <div class="row"> <div class="grid-3 grid-m-6 grid-s-12 campo-container"> <input name="faq[' +
    nextID +
    '][titulo]" id="titulo" type="text" value="" placeholder="Título" class="campo"> </div> <div class="grid-7 grid-m-6 grid-s-12 campo-container"> <input name="faq[' +
    nextID +
    '][texto]" id="texto" type="text" value="" placeholder="Texto" class="campo"> </div> <a class="remove-novo-atributoFAQ btn btn-xs btn-warning" style="position: relative; top: 7px; left: 10px; cursor: pointer"><i class="fa fa-trash"></i> <strong>Remover</strong></a> </div>';


  $("#imendaHTMLFAQ").append(html);
}

/* FAQ */


